module.exports = __webpack_public_path__ + "img/colors_w.c55ce541.svg";